import actions from './actions'

// list helper 
import ListHelper from '../../utils/listHelper'

// compare function
const compareSameReport = (a, b) => {
    return a.fid === b.fid
}

const initState = {
    reports: [],
    textSearch: '',

    total: 0,
    pageSize: 8,
    pageIndex: 1,
    lastTextSearch: '',
    status: 0,

    selectedReport: [],
    tier_created: 1
}

const _handleUpdateListReports = (state, reports) => {
    let newReports = []
    let selectedReport = state.selectedReport
    console.log('set null avc', reports)

    if (!reports.length) {
        return {
            ...state,
            ...{
                reports: [],
            },
        }
    }

    for (let index = 0; index < reports.length; index++) {
        let report = {
            ...reports[index],
            ...{
                isSelect: ListHelper.checkItemInList(
                    selectedReport,
                    reports[index],
                    compareSameReport
                ),
            },
        }
        newReports.push(report)
    }

    return {
        ...state,
        ...{
            reports: newReports,
        },
    }
}

const _handleUpdateSelectReportState = (state, fid, selectState) => {
    let newReports = []
    const reports = state.reports
    let selectedReport = state.selectedReport

    for (let index = 0; index < reports.length; index++) {
        let isSelect = reports[index].isSelect
        let report = reports[index]
        if (reports[index].fid === fid) {
            isSelect = selectState

            report = {
                ...reports[index],
                ...{
                    isSelect,
                },
            }

            // update select list
            if (selectState === true) {
                if (
                    !ListHelper.checkItemInList(
                        selectedReport,
                        report,
                        compareSameReport
                    )
                )
                    selectedReport = ListHelper.insertItemToList(
                        selectedReport,
                        report
                    )
            } else {
                if (
                    ListHelper.checkItemInList(
                        selectedReport,
                        report,
                        compareSameReport
                    )
                )
                    selectedReport = ListHelper.deleteItemInList(
                        selectedReport,
                        a => compareSameReport(a, report)
                    )
            }
        }

        newReports.push(report)
    }

    return {
        ...state,
        ...{
            reports: newReports,
            selectedReport,
        },
    }
}

const _handleUpdateSelectedReport = (state, selectedReport) => {
    let newReports = []
    let reports = state.reports

    for (let index = 0; index < reports.length; index++) {
        let event = {
            ...reports[index],
            ...{
                isSelect: ListHelper.checkItemInList(
                    selectedReport,
                    reports[index],
                    compareSameReport
                ),
            },
        }
        newReports.push(event)
    }

    return {
        ...state,
        ...{
            reports: newReports,
            selectedReport,
        },
    }
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case actions.type.LOAD_LIST_REPORT:
            return state

        case actions.type.LOAD_LIST_REPORT_SUCCESS:
            return _handleUpdateListReports(state, action.payload.reports)

        case actions.type.UPDATE_TEXT_SEARCH:
            return {
                ...state,
                ...{
                    textSearch: action.payload.textSearch
                }
            }

        case actions.type.SEARCH_REPORT:
            return {
                ...state,
                ...{
                    lastTextSearch: state.textSearch
                }
            }

        case actions.type.CHANGE_PAGE_SIZE:
            return {
                ...state,
                ...{
                    pageSize: action.payload.pageSize,
                    pageIndex: 1
                }
            }

        case actions.type.CHANGE_CURRENT_PAGE:
            return {
                ...state,
                ...{
                    pageIndex: action.payload.pageIndex
                }
            }

        case actions.type.UPDATE_SELECT_STATE_REPORT:
            return _handleUpdateSelectReportState(state, action.payload.fid, action.payload.selectState)

        case actions.type.UPDATE_SELECTED_REPORT:
            return _handleUpdateSelectedReport(state, action.payload.reports)

        case actions.type.UPDATE_STATE:
            return {
                ...state,
                ...action.payload.state
            }

        case actions.type.UPDATE_TIER_CREATED:
            return {
                ...state,
                ...{
                    tier_created: action.payload.tier_created
                }
            }

        default:
            return state
    }
}

export default reducer